import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const colorMap = {
  green: {
    icon: 'bg-primary-50 text-primary border-primary-200',
    accent: 'from-primary-500/10 via-primary-500/0',
    ring: 'group-hover:border-primary-200',
  },
  amber: {
    icon: 'bg-amber-50 text-amber border-amber-200',
    accent: 'from-amber-500/10 via-amber-500/0',
    ring: 'group-hover:border-amber-200',
  },
  blue: {
    icon: 'bg-blue-50 text-blue-600 border-blue-200',
    accent: 'from-blue-500/10 via-blue-500/0',
    ring: 'group-hover:border-blue-200',
  },
  red: {
    icon: 'bg-red-50 text-red-600 border-red-200',
    accent: 'from-red-500/10 via-red-500/0',
    ring: 'group-hover:border-red-200',
  },
};

/**
 * trend: optional number, e.g. 12 or -4 (percent change). Omit to hide.
 */
const EditorStatCard = ({ icon: Icon, label, value, color = 'green', subtitle, trend }) => {
  const styles = colorMap[color] || colorMap.green;
  const isLoading = value === '—';

  return (
    <div
      className={`group relative overflow-hidden rounded-3xl border border-char-100 bg-white p-5 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md ${styles.ring}`}
    >
      {/* soft directional glow, purely decorative */}
      <div
        className={`pointer-events-none absolute -right-8 -top-8 h-28 w-28 rounded-full bg-gradient-to-br ${styles.accent} to-transparent blur-xl`}
        aria-hidden="true"
      />

      <div className="relative flex items-start justify-between">
        <div
          className={`inline-flex items-center justify-center rounded-2xl border p-2.5 ${styles.icon}`}
        >
          <Icon size={20} />
        </div>

        {typeof trend === 'number' && !isLoading && (
          <span
            className={`flex items-center gap-0.5 rounded-full px-2 py-1 text-xs font-extrabold ${
              trend >= 0 ? 'bg-primary-50 text-primary' : 'bg-red-50 text-red-600'
            }`}
          >
            {trend >= 0 ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
            {Math.abs(trend)}%
          </span>
        )}
      </div>

      <p className={`relative mt-4 text-3xl font-extrabold tracking-tight text-char-900 ${isLoading ? 'animate-pulse text-char-200' : ''}`}>
        {value}
      </p>
      <p className="relative mt-1 text-sm font-bold text-char-500">{label}</p>
      {subtitle && <p className="relative mt-0.5 text-xs text-char-400">{subtitle}</p>}
    </div>
  );
};

export default EditorStatCard;